import React from "react";
import PropTypes from "prop-types";

import Backup from "./Backup";
import Restore from "./Restore";
import BackupSettings from "./BackupSettings";
import { forbidExtraProps } from "utils";
import Empty from "./NoLogs";
import VirtualizationLogs from "./Virtualization";

function body(props) {
  return (
    <div className="slider_backup_logs_body">
      <div className="logs_items_wrap">
        {props.logs.length !== 0 ? (
          props.logs.map((val, i) => (
            <React.Fragment key={i}>
              {val.type === 1 ? (
                <Backup {...{ ...val, enums: props.enums }} />
              ) : val.type === 2 ? (
                <Restore {...{ ...val, enums: props.enums, index: i }} />
              ) : val.type === 4 ? (
                <VirtualizationLogs
                  {...{ ...val, enums: props.virtEnums, index: i }}
                />
              ) : (
                <BackupSettings {...{ ...val, enums: props.enums, index: i }} />
              )}
            </React.Fragment>
          ))
        ) : (
          <Empty />
        )}
      </div>
    </div>
  );
}

body.propTypes = forbidExtraProps(
  {
    logs: PropTypes.arrayOf(
      PropTypes.shape({
        timeStamp: PropTypes.number,
        type: PropTypes.number,
        data: PropTypes.shape({
          duration: PropTypes.number,
          mode: PropTypes.number,
          msg: PropTypes.string,
          size: PropTypes.number,
          status: PropTypes.number,
          volumes: PropTypes.string
        })
      })
    )
  },
  ["fetchAppLogsStart", "enums"]
);

export default body;
